import React from 'react';
import styled from 'styled-components';

import Text from '@basic/Text';
import theme from '@theme';

const { colors } = theme;

const HamburgerMenuIcon = styled.span`
	width: 30px;
	:after,
	:before,
	div {
		background-color: ${props =>
			props.darkMenu ? colors.white : colors.grayscale.charcoal};
		border-radius: 1px;
		content: '';
		display: block;
		height: 3px;
		margin: 7px 0;
		transition: all 0.25s ease-in-out;
	}
	:before {
		transform: ${props =>
			props.open
				? `translateY(10px) rotate(135deg)`
				: `translateY(0) rotate(0)`};
	}
	:after {
		transform: ${props =>
			props.open
				? `translateY(-10px) rotate(-135deg)`
				: `translateY(0) rotate(0)`};
	}
	div {
		transform: ${props => (props.open ? `scale(0)` : `scale(1)`)};
	}
	:hover {
		cursor: pointer;
	}
	display: block;
	${props => props.theme.mediaQuery.breakpointLg} {
		display: none;
	}
`;

export default ({ toggle, open, darkMenu, className }) => (
	<HamburgerMenuIcon
		open={open}
		onClick={toggle}
		darkMenu={darkMenu}
		className={className}
	>
		<div />
	</HamburgerMenuIcon>
);
